<h1 translate>WORK_ORDERS_LIST</h1>
<div class="text-right mb-3">
  <button class="btn btn-primary" type="button" [routerLink]="['/working-order']" translate>
    CREATE_WORK_ORDER
  </button>
</div>
<lib-filter-list *ngIf="!isLoading" [configService]="configService"></lib-filter-list>
